<template>
  <div class="faq-page__wrapper">
    <Banner
      v-if="$vuetify.breakpoint.mdAndUp"
      id="main-content"
      heading="Help & About - FAQs"
      subtitle="Answers to some of the more commonly identified questions for the Resource Hub"
      icon="help_outline"
      :icon-size="bannerIconSize"
      tabindex="-1"
    />
    <div class="faq-content__container">
      <AdsExpansionPanel
        :items="items"
      />
    </div>
  </div>
</template>
<script>
import {Banner, AdsExpansionPanel} from '@nswdoe/doe-ui-core';

export default {
  name: 'FAQPage',
  components: {
    Banner,
    AdsExpansionPanel
  },
  data() {
    return {
      bannerIconSize: '3.5rem',
      items: [
        {
          title: 'Who has access to the Resources Hub?',
          content: 'The Universal Resources Hub is available for all schools and corporate staff working in the NSW Department of Education, and to pre-service teachers completing their placements in NSW public schools.'
        },
        {
          title: 'What is a collection? How do I create or add to a collection?',
          content: `Collection is a group of resources created to share with colleagues or teachers.
          <br>
          Collections discovered from URH searches provide an association between multiples resources. Content creators may define learning sequences within collections to show the order in which resources can be used.
          <br>
          Create a collection by grouping multiple published resource cards on the Universal Resources Hub (URH) via an individual resource card or by selecting ‘My Collections’ on the left side menu.

          <br>
            <strong>Via individual resource cards:</strong>
            <ul><li>There are two ways to add to a collection via an individual resource card.</li>
            <li>On an unopened individual resource card, select the bookmark icon (hover text is ‘Save to Collection’).</li>
            <li>On an opened individual resource card, select ‘Add to Collection’.</li>
            <li>Choose from your list of existing collections or create a new collection by selecting ‘New Collection’ and filling in the relevant metadata.</li>
            </ul>
            <strong>Via ‘My Collections’:</strong>
            <ul>
            <li>Create, access and collaborate on collections created by yourself or a colleague.</li>
            <li>To create a new collection, select “My Collections” on the left side menu and select “New Collection” in the menu option and fill in the relevant metadata.</li>
          </ul>`

        },
        {
          title: 'If I remove a resource from a collection, will it stay in the URH?',
          content: 'Yes, it will stay in URH.'
        },
        {
          title: 'What should I do if I am unable to access a resource card?',
          content: `Try clearing your browser’s cache and cookies.

          <ul>
            <li><strong>Google Chrome:</strong> Go to Settings> Privacy and Security> Clear Browsing Data</li>
            <li><strong>Firefox: </strong>Select the Menu button> Options> Privacy and Security> Cookies and Site Data> Clear Data</li>
            <li><strong>Edge: </strong>Go to Settings> Privacy, search and services> Clear browsing data</li>
          </ul>
          <br>
          If that doesn’t work, please reach out to us at urhsupport@det.nsw.edu.au or use the feedback button in the URH. Sometimes cards may be temporarily unavailable during an update.`
        },
        {
          title: 'How do I reset my areas of interest in URH to suggest relevant resources if I have changed my school?',
          content: `Select the Settings button on the left side menu of the URH and change the options under areas of interest. Then you can make changes under learning areas, stages and school improvement resources. Note: This only affects the resources visible on the ‘home page’.`
        },
        {
          title: 'How will school-facing staff be made aware of any changes to the Universal Resources Hub?',
          content: `Users will be made aware of any changes to the URH via the URH Viva Engage group, the Staff Noticeboard, statewide staffrooms and principal webinar sessions.
          <br>
          <br>
          All new updates will be listed in the ‘Releases’ under the Help & About section of the URH. Communication and engagement activities for education support staff and school-facing staff will also continue as new content and functionality is released.`
        },
        {
          title: 'Who can I contact further to ask questions or give feedback about the Resources Hub?',
          content: 'Share your compliments, complaints and suggestions about the URH by getting in touch with the URH team by email at URHsupport@det.nsw.edu.au or use the feedback button in the URH in the bottom left corner of the screen.'
        },
        /*        {
                  title: 'Can I save resources for later?',
                  content: 'Yes, as of Release 3.0 of the Hub, you are now able to save searches and bookmark / save resources to the new “My Resources” section, please visit the tutorials for more information.'
                },*/
        {
          title: 'How can I share resources with staff?',
          content: 'Once you have opened a resource (from the search result or ‘My resources’), select ‘Share via’ to share it with a colleague via email, Google Classroom, Microsoft Teams or a direct link.'
        },
        {
          title: 'What is the AI search?',
          content: `
            The AI search delivers improved search results for staff by interpreting the meaning and context of words and phrases rather than matching exact words like standard search. It also searches INSIDE the attached resources as opposed to using the meta-data defined in the resource cards
            <br><br>
            It’s optional to use, and staff can easily move between the standard search and the AI search using the toggle switch (on/off button) on the URH homepage.
            <br><br>
            Check out the
            <a href="https://resources.education.nsw.gov.au/api/v1/blob-store/dXJoX215cmVzb3VyY2VfY2Y4MTg2ODctNjE3YS00ZDU1LWE0YjUtY2RiYzllMzgyM2Qw=/VVJIIEFJIHNlYXJjaCBRUkcucGRm=?versionid=" target="_blank">QRG (PDF 61.3 KB)</a>
            and
            <a href="https://players.brightcove.net/6153144530001/9KBYgAVYb_default/index.html?videoId=6365612495112" target="_blank">videoExternal link</a>
            for tips on getting the most out of the AI search.
          `
        },
        {
          title: 'What web browsers are supported by the Universal Resources Hub?',
          content:'Google Chrome or MS Edge Chromium are the recommended browsers. Safari can be used. Internet Explorer or other browsers are not supported.'
        },
        {
          title: 'What resources are available in the Universal Resources Hub?',
          content:`You can filter by More Filters Owner to find relevant resources.
          <br>
          <ol class=" list-alpha-paren">
            <li><strong>Aboriginal Education </strong>- resources to support schools and staff to deliver high-quality, equitable and culturally inclusive education to improve the educational outcomes of Aboriginal and/or Torres Strait Islander students. </li>
            <li><strong>Attendance </strong>- resources which support schools to plan and implement attendance strategies that create a positive environment for engagement and learning.</li>
            <li><strong>Behaviour </strong>- resources to support staff to implement strategies to support positive student behaviour and anti-bullying at a school-wide, classroom and individual student level.</li>
            <li><strong> Communications and Engagement </strong>-                   
              <ol class="list-roman-paren">
                  <li><strong>Building productive partnerships: </strong>a resource that can be used to support the working relationship of principals and school leaders and their local P&C Association. </li>
                  <li><strong>Parent and Community partnerships- Learning Ecosystems</strong>: These resources provide evidence-based approaches to support school leaders and teams to develop initiatives that foster parent partnerships that enhance student learning.</li>
              </ol>
            </li>
            <li><strong> Curriculum </strong>- quality-assured learning resources produced by the Primary Curriculum, Secondary Curriculum and Curriculum Implementation and Provision teams.</li>
            <li><strong> Disability Inclusion </strong>- evidence-informed resources for schools to support students with disability.</li>
            <li><strong> EAL/D Education </strong>- resources to provide guidance to teachers and school leaders on meeting the learning needs of students learning English as an additional language or dialect.</li>
            <li><strong> Feedback and Complaints </strong>- guidance for principals and line managers on addressing complaints from parents, carers, students and community members.</li>
            <li><strong> Financial Management </strong>- resources to support school leaders and administrative staff to implement financial processes and practices within their school context as part of the <a href="https://education.nsw.gov.au/inside-the-department/school-excellence/school-excellence-plan" target="_blank">School Excellence cycle.</a></li>
            <li><strong> Literacy and Numeracy</strong> - evidence-based resources including learning sequences and guides to support schools to implement effective literacy and numeracy practices within their teaching and learning cycle.</li>
            <li><strong> Multicultural and Anti-racism education </strong>- resources to build intercultural understanding, develop culturally responsive school practices and eliminate racism.</li>
            <li><strong> NSW SLL Public </strong>- The NSW Student learning library (NSW SLL) is a suite of quality-assured, student-facing learning resources aligned to current syllabuses. The resources are accessible to teachers, parents and carers, and students to be used in class or at home. The NSW SLL resources on the URH include K-2 English and Mathematics resources, and student-facing resources that are part of Literacy and Numeracy Resource Packages.</li>
            <li><strong> Pathways</strong> - resources provide both school improvement and teaching and learning support to school leaders and teachers to enable the provision of diverse and meaningful pathways for secondary students.</li>
            <li>
                <strong> Principal Development </strong>-
                <ol class="list-roman-paren">
                  <li>
                    <strong>SLI:</strong>
                    Leadership development resources from the School Leadership Institute to support the leadership growth of principals and their staff.</li>
                  </li>
                  <li>
                    <strong>Performance and Accreditation:</strong>
                    Performance and development resources to guide principals through the Plan, Implement and Review phases of the performance and development cycle and make the most of the PDP for their professional growth.
                  </li>
                </ol>
            </li>
            <li><strong> School Excellence </strong>- School Excellence resources support school leaders to implement and embed key aspects of the School Excellence Cycle within their school context.</li>
            <li><strong> Stem.T4L </strong>- stem.T4L Learning Library offers resources for the stem.T4L kits to help teachers successfully integrate STEM concepts into their classrooms.</li>
          </ol>`
        },
        {
          title: 'What should I do if I find a problem with a resource or the data in a resource card?',
          content:'Get in touch with the URH team by email at URHsupport@det.nsw.edu.au or via the feedback button in the hub.'
        },
         {
          title: `What's new in the URH?`,
          content: 'Find out about the latest updates under Help & About > Releases'
        }
      ],
      isFAQ: true,
      isRoadmap: false,
    };
  },
  methods: {
    showFAQContent: function (event) {
      if (event.target.innerText == 'FREQUENTLY ASKED QUESTIONS') {
        this.isFAQ = true;
        this.isRoadmap = false;
      }
    },
    showRoadmapContent: function (event) {
      if (event.target.innerText == 'ROAD MAP') {
        this.isRoadmap = true;
        this.isFAQ = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-page__wrapper {
  min-height: 100%;
  margin-top: 12px;

  .faq-content__container {
    display: flex;
    justify-content: center;
    margin: 60px;
  }

  ::v-deep .list-alpha-paren {
    list-style: none;
    counter-reset: custom-alpha-counter;

    > li {
      counter-increment: custom-alpha-counter;

      &::before {
        content: counter(custom-alpha-counter, lower-alpha) ") ";
        min-width: 20px;
        font-weight: bold;
        margin-right: 0;
      }

      /* Level 2: i), ii), iii) */
      .list-roman-paren {
        list-style: none;
        counter-reset: roman-counter;
        padding-left: 1.5em;
        > li {
          counter-increment: roman-counter;
        }
        > li::before {
          content: counter(roman-counter, lower-roman) ". ";
          font-weight: bold;
        }
        }
    }
  }
}

@media only screen and (max-width: 960px) and (min-height: 600px) {
  .faq-page__wrapper {
    margin-top: 0;

    .faq-content__container {
      margin: 24px;
    }
  }
}

@media only screen and (max-width: 600px) {
  .faq-page__wrapper {
    margin-top: 0;

    .faq-content__container {
      margin: 12px;
    }
  }
}
</style>
